import React, { useState } from 'react';

import { ApIcon } from '@alixpartners/ui-components';
import { MainWrapper, SidebarItem, SideBarNav } from '../CategoryWidget.styles';
import DashBoard from '../DashBoard';

function TempLabour({ setCurrentContent }) {
	const [currentTab, setCurrentTab] = useState(0);

	return (
		<MainWrapper>
			<SideBarNav>
				<SidebarItem active={currentTab === 0} onClick={() => setCurrentTab(0)}>
					<ApIcon iconName="hub" material />
					<span>BLS Data</span>
				</SidebarItem>
				<SidebarItem active={currentTab === 1} onClick={() => setCurrentTab(1)}>
					<ApIcon iconName="insights" material />
					<span>Client Data</span>
				</SidebarItem>
			</SideBarNav>
			<DashBoard
				setCurrentContent={setCurrentContent}
				currentTab={currentTab}
			/>
		</MainWrapper>
	);
}

export default TempLabour;
